export default {
  // Common
  common: {
    save: 'Salva',
    cancel: 'Annulla',
    delete: 'Elimina',
    edit: 'Modifica',
    create: 'Crea',
    search: 'Cerca',
    filter: 'Filtra',
    loading: 'Caricamento...',
    noData: 'Nessun dato',
    confirm: 'Conferma',
    close: 'Chiudi',
    yes: 'Sì',
    no: 'No',
    actions: 'Azioni',
    status: 'Stato',
    date: 'Data',
    name: 'Nome',
    description: 'Descrizione',
    type: 'Tipo',
    download: 'Scarica',
    upload: 'Carica',
    copy: 'Copia',
    copied: 'Copiato!',
    error: 'Errore',
    success: 'Successo',
    warning: 'Attenzione',
    info: 'Informazione',
    all: 'Tutto',
    allTypes: 'Tutti i tipi',
    allStatuses: 'Tutti gli stati',
    none: 'Nessuno',
    active: 'Attivo',
    inactive: 'Inattivo',
    enabled: 'Abilitato',
    disabled: 'Disabilitato',
    refresh: 'Aggiorna',
    back: 'Indietro',
    next: 'Avanti',
    previous: 'Precedente',
    finish: 'Fine',
    submit: 'Invia',
    confirmDeleteItem: 'Vuoi eliminare questo elemento?',
    validateForReport: 'Valida per Report',
    reset: 'Reimposta',
    view: 'Visualizza',
    details: 'Dettagli',
    more: 'Altro',
    less: 'Meno',
    today: 'Oggi',
    yesterday: 'Ieri',
    thisWeek: 'Questa settimana',
    thisMonth: 'Questo mese',
    optional: 'Opzionale',
    required: 'Richiesto',
    note: 'Nota:',
    and: 'e'
  },

  // Navigation
  nav: {
    dashboard: 'Dashboard',
    scans: 'Scansioni',
    workspaces: 'Workspaces',
    vulnerabilities: 'Vulnerabilità',
    reports: 'Report',
    settings: 'Impostazioni',
    account: 'Il mio account',
    logout: 'Esci',
    help: 'Aiuto',
    admin: 'Amministrazione',
    tools: 'Strumenti',
    compliance: 'Conformità',
    notifications: 'Notifiche',
    credentials: 'Credenziali',
    ad: 'Active Directory'
  },

  // Auth
  auth: {
    login: 'Accedi',
    logout: 'Esci',
    register: 'Registrati',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Conferma password',
    forgotPassword: 'Password dimenticata?',
    magicLink: 'Magic Link',
    resetPassword: 'Reimposta password',
    resetPasswordNeedsLink: 'Per reimpostare la tua password, utilizza il link inviato via email. Puoi richiedere un nuovo link dalla pagina di accesso.',
    rememberMe: 'Ricordami',
    loginSuccess: 'Accesso riuscito',
    loginError: 'Credenziali non valide',
    logoutSuccess: 'Disconnessione riuscita',
    sessionExpired: 'Sessione scaduta',
    twoFactor: 'Autenticazione a due fattori',
    enterCode: 'Inserisci il codice',
    verifyCode: 'Verifica codice',
    invalidCode: 'Codice non valido',
    // Register page
    createAccount: 'Crea un account',
    fillFormBelowEmail: 'Compila il modulo qui sotto per creare il tuo account aziendale.',
    companyName: 'Nome azienda',
    companyPlaceholder: 'La tua azienda',
    firstName: 'Nome',
    firstNamePlaceholder: 'Il tuo nome',
    lastName: 'Cognome',
    lastNamePlaceholder: 'Il tuo cognome',
    professionalEmail: 'Email professionale',
    professionalEmailPlaceholder: 'tu@tuaazienda.it',
    professionalPhone: 'Telefono professionale',
    phonePlaceholder: '+39 123 456 7890',
    passwordEmailNote: 'Imposterai la password dopo la verifica dell\'email.',
    acceptTermsPrefix: 'Accetto i',
    createMyAccount: 'Crea il mio account',
    registering: 'Creazione in corso...',
    alreadyHaveAccount: 'Hai già un account?',
    loginButton: 'Accedi',
    byRegistering: 'Creando un account, accetti i nostri termini di utilizzo e la politica sulla privacy.',
    registrationSuccess: 'Registrazione riuscita!',
    registrationEmailSent: 'Un\'email di conferma è stata inviata a',
    clickLinkToSetPassword: 'Clicca sul link per impostare la password e attivare il tuo account.',
    checkSpam: 'Controlla la cartella spam se non vedi l\'email.',
    backToLogin: 'Torna al login',
    // Email verification
    verifying: 'Verifica in corso...',
    verifyingDescription: 'Attendere mentre verifichiamo il tuo indirizzo email.',
    emailVerified: 'Email verificata!',
    accountActive: 'Il tuo account è ora attivo.',
    welcome: 'Benvenuto su SYLink!',
    choosePlan: 'Scegli il mio piano',
    redirectingToPlan: 'Reindirizzamento ai prezzi tra {seconds} secondi...',
    orLoginDirectly: 'Oppure {loginLink} direttamente',
    verificationFailed: 'Verifica fallita',
    needNewVerificationLink: 'Hai bisogno di un nuovo link di verifica?',
    yourEmail: 'La tua email',
    emailSent: 'Email inviata!',
    resendLink: 'Reinvia link',
    invalidLink: 'Link non valido',
    requestNewVerificationLink: 'Richiedi un nuovo link di verifica',
    sendLink: 'Invia link',
    // Login page
    welcomeBack: 'Bentornato!',
    enterCredentials: 'Inserisci le tue credenziali per accedere al tuo spazio.',
    loggingIn: 'Accesso in corso...',
    noAccount: 'Non hai un account?',
    createAccountLink: 'Crea un account',
    createFreeAccount: 'Crea un account gratuito',
    // Password reset
    resetPasswordTitle: 'Reimposta password',
    resetPasswordDesc: 'Inserisci la tua email per ricevere un link di reimpostazione.',
    sendResetLink: 'Invia link',
    sending: 'Invio in corso...',
    resetLinkSent: 'Link inviato!',
    resetLinkSentDesc: 'Controlla la tua casella di posta per reimpostare la password.',
    newPassword: 'Nuova password',
    confirmNewPassword: 'Conferma password',
    setNewPassword: 'Imposta password',
    passwordUpdated: 'Password aggiornata!',
    passwordUpdatedDesc: 'Ora puoi accedere con la tua nuova password.'
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    welcome: 'Benvenuto, {name}',
    overview: 'Panoramica',
    recentScans: 'Scansioni recenti',
    statistics: 'Statistiche',
    quickActions: 'Azioni rapide',
    newScan: 'Nuova scansione',
    viewAllScans: 'Vedi tutte le scansioni',
    totalScans: 'Scansioni totali',
    activeScans: 'Scansioni attive',
    completedScans: 'Scansioni completate',
    failedScans: 'Scansioni fallite',
    vulnerabilitiesFound: 'Vulnerabilità trovate',
    criticalVulns: 'Vulnerabilità critiche',
    highVulns: 'Vulnerabilità alte',
    mediumVulns: 'Vulnerabilità medie',
    lowVulns: 'Vulnerabilità basse',
    systemHealth: 'Stato del sistema',
    toolsStatus: 'Stato degli strumenti',
    cpuUsage: 'Utilizzo CPU',
    memoryUsage: 'Utilizzo memoria',
    diskUsage: 'Utilizzo disco',
    // Service status
    services: {
      backendApi: 'API Backend',
      frontend: 'Frontend',
      postgresql: 'PostgreSQL',
      aiModels: 'Modelli IA'
    },
    serviceStatus: {
      online: 'Online',
      offline: 'Offline',
      checking: 'Controllo',
      degraded: 'Degradato'
    }
  },

  // Scans
  scans: {
    title: 'Scansioni',
    newScan: 'Nuova scansione',
    scanHistory: 'Cronologia scansioni',
    target: 'Obiettivo',
    targets: 'Obiettivi',
    scanType: 'Tipo di scansione',
    startScan: 'Avvia scansione',
    stopScan: 'Interrompi scansione',
    pauseScan: 'Pausa',
    resumeScan: 'Riprendi',
    deleteScan: 'Elimina scansione',
    scanDetails: 'Dettagli scansione',
    scanResults: 'Risultati scansione',
    progress: 'Progresso',
    duration: 'Durata',
    startedAt: 'Iniziato il',
    completedAt: 'Completato il',
    status: {
      waiting: 'In coda',
      pending: 'In attesa',
      running: 'In corso',
      completed: 'Completato',
      failed: 'Fallito',
      cancelled: 'Annullato',
      paused: 'In pausa'
    },
    types: {
      quick: 'Scansione rapida',
      full: 'Scansione completa',
      stealth: 'Scansione stealth',
      aggressive: 'Scansione aggressiva',
      custom: 'Scansione personalizzata',
      iot_scan: 'Scansione IoT',
      ot_scan: 'Scansione OT/SCADA',
      full_autonomous: 'Autonomo completo',
      full_auto: 'Autonomo completo',
      full_automation: 'Autonomo completo',
      network_discovery: 'Scoperta rete',
      vulnerability_scan: 'Scansione vulnerabilità',
      expert: 'Scansione esperta',
      api_pentest: 'Pentest API',
      ad_pentest: 'Pentest Active Directory',
      ad_scan: 'Scansione Active Directory',
      wifi_pentest: 'Pentest Wi-Fi',
      social_engineering: 'Ingegneria sociale',
      red_team: 'Red Team',
      phishing: 'Campagna di phishing'
    },
    phases: {
      discovery: 'Scoperta',
      portScan: 'Scansione porte',
      serviceDetection: 'Rilevamento servizi',
      vulnScan: 'Scansione vulnerabilità',
      exploitation: 'Sfruttamento',
      reporting: 'Reportistica'
    },
    stealthMode: {
      title: 'Modalità Stealth',
      description: 'Tecniche di evasione IDS/IPS',
      none: 'Nessuno',
      noneDesc: 'Scansione veloce, facilmente rilevabile',
      basic: 'Base',
      basicDesc: 'Pacchetti frammentati',
      advanced: 'Avanzato',
      advancedDesc: 'Tempistica lenta + spoofing',
      paranoid: 'Paranoico',
      paranoidDesc: 'Massima evasione (molto lento)',
      warning: 'Le modalità stealth utilizzano tecniche di evasione per evitare il rilevamento IDS/IPS'
    },
    hosts: 'Host',
    ports: 'Porte',
    services: 'Servizi',
    openPorts: 'Porte aperte',
    closedPorts: 'Porte chiuse',
    filteredPorts: 'Porte filtrate',
    noResults: 'Nessun risultato trovato',
    exportResults: 'Esporta risultati',
    scanFailed: 'Scansione fallita',
    genericError: 'Si è verificato un errore durante l\'esecuzione della scansione. Ciò potrebbe essere dovuto a problemi di connettività di rete, obiettivi non raggiungibili o risorse insufficienti.',
    technicalDetails: 'Dettagli tecnici',
    retryScan: 'Riprova questa scansione',
    // Cleanup mode
    cleanup: 'Pulizia',
    cleanupTitle: 'Pulizia post-pentest',
    cleanupDescription: 'Questa azione rimuoverà tutte le tracce lasciate dal pentest, inclusi:',
    cleanupSessions: 'Sessioni di exploitation attive',
    cleanupPersistence: 'Meccanismi di persistenza installati',
    cleanupFiles: 'File temporanei ed evidenze',
    cleanupLogs: 'Log di esecuzione APT',
    cleanupPreview: 'Anteprima pulizia',
    sessionsCount: 'Sessioni',
    withPersistence: 'Con persistenza',
    aptExecutions: 'Esecuzioni APT',
    evidenceFiles: 'File di evidenza',
    evidenceSize: 'Dimensione evidenze',
    cleanNow: 'Pulisci ora',
    archiveAndClean: 'Archivia e pulisci',
    cleaning: 'Pulizia...',
    cleanupSuccess: 'Pulizia completata con successo',
    cleanupPartial: 'Pulizia parziale (alcuni errori)',
    cleanupFailed: 'Pulizia fallita',
    sessionsClosed: 'Sessioni chiuse',
    persistenceRemoved: 'Persistenza rimossa',
    filesCleaned: 'File puliti',
    aptLogsCleaned: 'Log APT puliti',
    evidenceArchived: 'Evidenze archiviate',
    cleanupWarning: '⚠️ Questa azione è irreversibile. Assicurati di aver salvato i dati importanti.'
  },

  // Workspaces
  workspaces: {
    title: 'Aree clienti',
    newWorkspace: 'Nuova area',
    editWorkspace: 'Modifica area',
    deleteWorkspace: 'Elimina area',
    workspaceDetails: 'Dettagli area',
    clientName: 'Nome cliente',
    clientInfo: 'Informazioni cliente',
    members: 'Membri',
    addMember: 'Aggiungi membro',
    removeMember: 'Rimuovi membro',
    scansCount: 'Numero di scansioni',
    lastActivity: 'Ultima attività',
    created: 'Creato il',
    shareWorkspace: 'Condividi area',
    archiveWorkspace: 'Archivia area',
    noWorkspaces: 'Nessuna area cliente',
    // Form labels
    siret: 'SIRET',
    siretPlaceholder: 'Es: 123 456 789 00001',
    siren: 'SIREN',
    sirenPlaceholder: 'Es: 123 456 789',
    // Additional workspace keys
    scans: 'Scansioni',
    hosts: 'Host',
    vulnerabilities: 'Vulnerabilità',
    attackPaths: 'Percorsi di attacco',
    successfulScans: 'Scansioni riuscite',
    company: 'Azienda',
    legalForm: 'Forma giuridica',
    address: 'Indirizzo',
    city: 'Città',
    website: 'Sito web',
    shareDescription: 'Condividi questa area con i tuoi clienti o collaboratori',
    manageShares: 'Gestisci condivisioni',
    mainContact: 'Contatto principale',
    contact: 'Contatto',
    signed: 'Firmato',
    pending: 'In attesa',
    draft: 'Bozza',
    contractSigned: 'Contratto firmato',
    pendingContract: 'Contratto in attesa',
    noContract: 'Nessun contratto',
    noScans: 'Nessuna scansione associata',
    noScansHint: 'Associa una scansione esistente o avviane una nuova dalla pagina Scansioni',
    noHosts: 'Nessun host',
    noVulnerabilities: 'Nessuna vulnerabilità',
    noAttackPaths: 'Nessun percorso di attacco',
    // Network stats
    vulnerable: 'Vulnerabili',
    subnets: 'Sottoreti',
    services: 'Servizi',
    noAttackTree: 'Nessun albero di attacco',
    noVPN: 'Nessun VPN configurato',
    // AI Analysis
    aiAnalysis: 'Analisi IA',
    generateSummary: 'Genera riepilogo',
    launchAiAnalysis: 'Avvia analisi IA',
    analysisInProgress: 'Analisi in corso...',
    completeAnalysis: 'Analisi completa e Soluzioni',
    aggregatedData: 'Dati aggregati',
    riskAnalysis: 'Analisi dei rischi',
    clickToGenerateSummary: 'Clicca su "Genera riepilogo" per ottenere un\'analisi IA',
    noAnalysisAvailable: 'Nessuna analisi disponibile',
    clickToLaunchAnalysis: 'Clicca sul pulsante sopra per avviare l\'analisi IA',
    launchScanToDiscoverNetwork: 'Avvia una scansione per scoprire la rete',
    critical: 'Critiche',
    high: 'Alte',
    download: 'Scarica',
    deleteStoredCredentials: 'Elimina credenziali salvate',
    useStoredCredentials: 'usa credenziali salvate',
    enterVpnUsername: 'Inserisci il tuo nome utente VPN',
    enterVpnPassword: 'Inserisci la tua password VPN',
    // VPN Modal
    actionPlan: 'Piano d\'azione & Soluzioni',
    noDocuments: 'Nessun documento generato per questo workspace',
    reportsWillAppear: 'I report appariranno qui dopo la generazione',
    vpnCredentials: 'Credenziali VPN',
    requiresAuthentication: 'richiede autenticazione',
    storedCredentials: 'Credenziali salvate',
    clickToUseCredentials: 'Clicca su "Connetti" per usare queste credenziali',
    connect: 'Connetti',
    cancel: 'Annulla',
    username: 'Nome utente',
    password: 'Password',
    saveCredentials: 'Salva queste credenziali',
    saveCredentialsSecurely: 'Salva credenziali in modo sicuro',
    credentialsStorageInfo: 'Le credenziali saranno crittografate (AES-256) e memorizzate nel database. Verranno utilizzate automaticamente per le future connessioni VPN.',
    saving: 'Salvataggio...',
    connecting: 'Connessione...',
    server: 'Server',
    protocol: 'Protocollo',
    noVulnsToFix: 'Nessuna vulnerabilità da correggere',
    connectionInProgress: 'Connessione in corso...',
    connectionFailed: 'Connessione fallita',
    generateActionPlan: 'Genera piano d\'azione',
    clickToGenerateActionPlan: 'Clicca su "Genera piano d\'azione" per ottenere raccomandazioni',
    vpnConnected: 'VPN connesso! IP:',

    // Workspace Switcher
    selectTitle: 'Seleziona workspace',
    selectDescription: 'Scegli un workspace per continuare',
    searchPlaceholder: 'Cerca workspace...',
    noWorkspacesYet: 'Nessun workspace ancora',
    noResults: 'Nessun workspace corrispondente',
    createFirst: 'Crea il tuo primo workspace',
    createNew: 'Crea nuovo',
    continue: 'Continua',
    switchError: 'Errore nel cambio di workspace',
    scan: 'scansione',
    scans: 'scansioni',
    select: 'Seleziona workspace',
    manageAll: 'Gestisci workspace',
    noWorkspaces: 'Nessun workspace trovato',
    switching: 'Cambio in corso...',
    switchSuccess: 'Workspace cambiato con successo',
    autoSelected: 'Workspace selezionato automaticamente',
    pleaseSelect: 'Seleziona un workspace per continuare',
    activeWorkspace: 'Workspace attivo'
  },

  // Vulnerabilities
  vulnerabilities: {
    title: 'Vulnerabilità',
    subtitle: 'Analisi e gestione delle vulnerabilità rilevate',
    vulnerability: 'Vulnerabilità',
    severity: 'Gravità',
    severities: {
      critical: 'Critica',
      high: 'Alta',
      medium: 'Media',
      low: 'Bassa',
      info: 'Informativa'
    },
    cve: 'CVE',
    cvss: 'Punteggio CVSS',
    affected: 'Interessato',
    solution: 'Soluzione',
    references: 'Riferimenti',
    evidence: 'Prove',
    exploitable: 'Sfruttabile',
    verified: 'Verificato',
    falsePositive: 'Falso positivo',
    validation: {
      confirmed: 'Confermato sfruttabile',
      theoretical: 'Teorico',
      not_exploitable: 'Non sfruttabile',
      unvalidated: 'Non validato',
      poc_title: 'Prova di Concetto',
      narrative: 'Narrativa di sfruttamento',
      exploit_path: 'Percorso di exploit',
      prerequisites: 'Prerequisiti',
    },
    markAsFixed: 'Segna come risolto',
    noVulnerabilities: 'Nessuna vulnerabilità trovata',
    export: 'Esporta vulnerabilità',
    distributionBySeverity: 'Distribuzione per Gravità',
    priority: {
      auto: 'Automatico',
    },
    // Attack Chain
    attackChain: {
      title: 'Classifica delle Catene di Attacco',
      subtitle: 'Analisi dei rischi multi-vulnerabilità per penetrare il target',
      riskScore: 'Punteggio di rischio',
      vulnCount: 'vulnerabilità',
      attackPath: 'Percorso di attacco verso l\'obiettivo',
      // Chart
      chartTitle: 'Distribuzione delle Vulnerabilità',
      chartSubtitle: 'Analisi statistica delle CVE rilevate',
      bySeverity: 'Distribuzione per Severità',
      keyMetrics: 'Metriche Chiave',
      totalVulns: 'Totale CVE',
      avgCvss: 'CVSS Medio',
      criticalHigh: 'Critico + Alto',
      affectedHosts: 'Host Colpiti',
      topCves: 'Top CVE per CVSS',
      // Stages
      stages: {
        initialAccess: 'Accesso Iniziale',
        privEscalation: 'Escalation di Privilegi',
        persistence: 'Persistenza',
        objective: 'Obiettivo'
      },
      exploitVia: 'Sfruttamento via',
      escalationVia: 'Escalation via',
      maintenanceVia: 'Persistenza via',
      fullCompromise: 'Compromissione completa del sistema',
      adminAccess: 'Accesso admin possibile',
      initialSystemAccess: 'Accesso iniziale al sistema',
      // Risk Factors
      riskFactors: 'Fattori di rischio',
      factors: {
        multiVuln: 'Multi-vulnerabilità',
        multiVuln5: '{count} vuln concatenabili',
        multiVuln3: '{count} vuln su questo host',
        criticalHighCombo: 'Combo Critical + High',
        rce: 'RCE potenziale',
        authBypass: 'Bypass auth possibile',
        privEsc: 'Escalation privilegi',
        exposed: 'Servizi esposti',
        highCvss: 'CVSS medio {score}'
      },
      // Ratings
      ratingCritical: 'CRITICO',
      ratingHigh: 'ALTO',
      ratingMedium: 'MEDIO',
      ratingLow: 'BASSO',
      ratingSafe: 'SICURO',
      // Details
      criticalPath: 'PERCORSO CRITICO',
      vulnsInChain: 'Vulnerabilità in questa catena',
      noChains: 'Nessuna catena di attacco rilevata',
      noVulnsDesc: 'Nessuna vulnerabilità trovata per analizzare i percorsi di attacco.',
      viewDetails: 'Vedi dettagli',
      multiVulnWarning: 'Rischio aumentato: vulnerabilità multiple concatenabili',
      // Recommendations
      recommendation: 'Raccomandazione di sfruttamento',
      recoCritical: 'Questo target presenta un rischio critico. La combinazione di {count} vulnerabilità consente la compromissione completa del sistema. Massima priorità per la remediation.',
      recoHigh: 'Alto rischio di compromissione. Le vulnerabilità combinate offrono un percorso di attacco praticabile. Azione correttiva raccomandata al più presto.',
      recoMedium: 'Rischio moderato. Alcune vulnerabilità potrebbero essere concatenate per lo sfruttamento. Monitorare e correggere secondo priorità.',
      recoLow: 'Rischio basso. Le vulnerabilità presenti hanno impatto limitato e sono difficili da sfruttare in catena.',
      // Stats
      criticalPaths: 'Percorsi Critici',
      highRisk: 'Rischio Alto',
      multiVuln: 'Multi-Vuln (3+)',
      hostsAnalyzed: 'Host Analizzati',
      avgScore: 'Punteggio Medio',
      // Info
      infoText: 'Questa classifica identifica gli host più vulnerabili analizzando le combinazioni di vulnerabilità sfruttabili per raggiungere gli obiettivi di penetrazione.',
      // Legend
      legendCritical: 'Critico (80-100)',
      legendHigh: 'Alto (60-79)',
      legendMedium: 'Medio (40-59)',
      legendLow: 'Basso (20-39)',
      legendSafe: 'Sicuro (0-19)'
    }
  },

  // Reports
  reports: {
    title: 'Report',
    newReport: 'Nuovo report',
    generateReport: 'Genera report',
    downloadReport: 'Scarica report',
    reportType: 'Tipo di report',
    settings: 'Impostazioni',
    branding: 'Branding',
    types: {
      executive: 'Report esecutivo',
      technical: 'Report tecnico',
      compliance: 'Report di conformità',
      full: 'Report completo',
      vulnerability_list: 'Report vulnerabilità',
      redteam: 'Report Red Team',
      retest: 'Report di retest',
      multi_campaign: 'Report multi-campagna',
      active_directory: 'Report Active Directory',
      data_leak: 'Report fughe di dati',
      attack_surface: 'Report superficie di attacco'
    },
    format: 'Formato',
    formats: {
      pdf: 'PDF',
      html: 'HTML',
      json: 'JSON',
      csv: 'CSV',
      docx: 'Word (DOCX)',
      xml: 'XML',
      jira: 'Jira',
      servicenow: 'ServiceNow',
      glpi: 'GLPI',
      pptx: 'PowerPoint (PPTX)',
      txt: 'Testo (TXT)',
      xlsx: 'Excel (XLSX)'
    },
    includeEvidence: 'Includi prove',
    includeRemediation: 'Includi raccomandazioni',
    generatedAt: 'Generato il',
    generatedBy: 'Generato da',
    noReports: 'Nessun report',

    // Export modal
    export: {
      title: 'Esportazione',
      processing: 'Esportazione in corso...',
      generating: 'Generazione del file',
      takingLong: 'Questa operazione richiede più tempo del previsto.',
      canWaitOrEmail: 'Puoi attendere o chiudere questa finestra e ti invieremo un link via e-mail.',
      sendByEmail: 'Ricevi via e-mail',
      continueWaiting: 'Puoi anche continuare ad attendere, il download inizierà automaticamente.',
      emailSent: 'E-mail inviata!',
      emailSentDesc: 'Riceverai il link per il download via e-mail tra pochi istanti.',
      wordLocked: 'Disponibile per i piani Enterprise e superiori'
    }
  },

  // Account
  account: {
    title: 'Il mio account',
    profile: 'Profilo',
    security: 'Sicurezza',
    subscription: 'Abbonamento',
    billing: 'Fatturazione',
    credits: 'Crediti',
    notifications: 'Notifiche',
    integrations: 'Integrazioni',
    referral: 'Referral',
    activity: 'Attività',
    contracts: 'Contratti',

    // Profile section
    profileSection: {
      title: 'Informazioni profilo',
      avatar: 'Foto profilo',
      changeAvatar: 'Cambia foto',
      removeAvatar: 'Rimuovi foto',
      firstName: 'Nome',
      lastName: 'Cognome',
      email: 'Email',
      phone: 'Telefono',
      company: 'Azienda',
      position: 'Posizione',
      timezone: 'Fuso orario',
      language: 'Lingua del portale',
      languageDescription: 'Scegli la lingua di visualizzazione dell\'interfaccia',
      updateSuccess: 'Profilo aggiornato con successo',
      updateError: 'Errore durante l\'aggiornamento del profilo'
    },

    // Security section
    securitySection: {
      title: 'Sicurezza account',
      changePassword: 'Cambia password',
      currentPassword: 'Password attuale',
      newPassword: 'Nuova password',
      confirmPassword: 'Conferma password',
      passwordRequirements: 'La password deve contenere almeno 8 caratteri',
      twoFactorAuth: 'Autenticazione a due fattori',
      enable2FA: 'Abilita 2FA',
      disable2FA: 'Disabilita 2FA',
      twoFactorEnabled: '2FA abilitata',
      twoFactorDisabled: '2FA disabilitata',
      activeSessions: 'Sessioni attive',
      revokeSession: 'Revoca sessione',
      revokeAllSessions: 'Revoca tutte le sessioni',
      loginHistory: 'Cronologia accessi',
      lastLogin: 'Ultimo accesso',
      apiKeys: 'Chiavi API',
      generateApiKey: 'Genera chiave API',
      deleteApiKey: 'Elimina chiave API'
    },

    // Subscription section
    subscriptionSection: {
      title: 'Abbonamento',
      currentPlan: 'Piano attuale',
      planDetails: 'Dettagli piano',
      features: 'Funzionalità incluse',
      usage: 'Utilizzo',
      limits: 'Limiti',
      renewalDate: 'Data di rinnovo',
      cancelSubscription: 'Annulla abbonamento',
      upgradePlan: 'Passa a un piano superiore',
      downgradePlan: 'Passa a un piano inferiore',
      plans: {
        free: 'Gratuito',
        pro: 'Pro',
        enterprise: 'Enterprise',
        dedicated: 'Dedicato'
      }
    },

    // Credits section
    creditsSection: {
      title: 'Gestione crediti',
      balance: 'Saldo',
      totalCredits: 'Crediti totali',
      monthlyCredits: 'Crediti mensili',
      packCredits: 'Crediti pacchetto',
      usedThisMonth: 'Usati questo mese',
      remaining: 'Rimanenti',
      buyCredits: 'Acquista crediti',
      creditHistory: 'Cronologia crediti',
      transaction: 'Transazione',
      amount: 'Importo',
      creditCosts: 'Costi operazioni',
      scanCost: 'Costo scansione',
      reportCost: 'Costo report'
    },

    // Notifications section
    notificationsSection: {
      title: 'Preferenze notifiche',
      emailNotifications: 'Notifiche email',
      pushNotifications: 'Notifiche push',
      scanCompleted: 'Scansione completata',
      scanFailed: 'Scansione fallita',
      newVulnerability: 'Nuova vulnerabilità critica',
      reportReady: 'Report pronto',
      securityAlerts: 'Avvisi di sicurezza',
      weeklyDigest: 'Riepilogo settimanale',
      marketingEmails: 'Email marketing'
    },

    // Integrations section
    integrationsSection: {
      title: 'Integrazioni',
      connected: 'Connesso',
      notConnected: 'Non connesso',
      configure: 'Configura',
      disconnect: 'Disconnetti',
      testConnection: 'Testa connessione',
      connectionSuccess: 'Connessione riuscita',
      connectionFailed: 'Connessione fallita',
      availableIntegrations: 'Integrazioni disponibili',
      myIntegrations: 'Le mie integrazioni'
    },

    // Referral section
    referralSection: {
      title: 'Programma referral',
      referralLink: 'Link di referral',
      copyLink: 'Copia link',
      shareLink: 'Condividi link',
      inviteFriends: 'Invita amici',
      referralStats: 'Statistiche referral',
      totalReferrals: 'Referral totali',
      pendingReferrals: 'Referral in attesa',
      completedReferrals: 'Referral completati',
      earnedCredits: 'Crediti guadagnati',
      inviteByEmail: 'Invita via email',
      contacts: 'Contatti invitati',
      rewards: 'Premi',
      leaderboard: 'Classifica'
    }
  },

  // Settings
  settings: {
    title: 'Impostazioni',
    general: 'Generali',
    tools: 'Strumenti',
    network: 'Rete',
    advanced: 'Avanzate',

    generalSection: {
      title: 'Impostazioni generali',
      defaultScanType: 'Tipo di scansione predefinito',
      defaultReportFormat: 'Formato report predefinito',
      autoSaveReports: 'Salvataggio automatico report',
      enableNotifications: 'Abilita notifiche',
      darkMode: 'Modalità scura',
      compactView: 'Vista compatta'
    },

    toolsSection: {
      title: 'Configurazione strumenti',
      enabledTools: 'Strumenti abilitati',
      toolSettings: 'Impostazioni strumenti',
      timeout: 'Timeout',
      threads: 'Numero di thread',
      verbosity: 'Livello di dettaglio'
    },

    networkSection: {
      title: 'Configurazione rete',
      proxySettings: 'Impostazioni proxy',
      vpnSettings: 'Impostazioni VPN',
      dnsSettings: 'Impostazioni DNS',
      useProxy: 'Usa proxy',
      proxyHost: 'Host proxy',
      proxyPort: 'Porta proxy'
    },

    // Server status
    uptime: 'Tempo di attività'
  },

  // Admin
  admin: {
    title: 'Amministrazione',
    users: 'Utenti',
    companies: 'Aziende',
    system: 'Sistema',
    logs: 'Log',
    maintenance: 'Manutenzione',

    usersSection: {
      title: 'Gestione utenti',
      addUser: 'Aggiungi utente',
      editUser: 'Modifica utente',
      deleteUser: 'Elimina utente',
      activateUser: 'Attiva utente',
      deactivateUser: 'Disattiva utente',
      resetPassword: 'Reimposta password',
      role: 'Ruolo',
      roles: {
        admin: 'Amministratore',
        user: 'Utente',
        viewer: 'Osservatore'
      },
      lastLogin: 'Ultimo accesso',
      createdAt: 'Creato il',
      noUsers: 'Nessun utente'
    },

    systemSection: {
      title: 'Sistema',
      systemInfo: 'Informazioni sistema',
      version: 'Versione',
      uptime: 'Tempo di attività',
      restart: 'Riavvia',
      backup: 'Backup',
      restore: 'Ripristina',
      update: 'Aggiorna'
    }
  },

  // Errors
  errors: {
    generic: 'Si è verificato un errore',
    notFound: 'Pagina non trovata',
    unauthorized: 'Accesso non autorizzato',
    forbidden: 'Accesso vietato',
    serverError: 'Errore del server',
    networkError: 'Errore di rete',
    timeout: 'Timeout scaduto',
    validation: 'Errore di validazione',
    invalidEmail: 'Email non valida',
    invalidPassword: 'Password non valida',
    passwordMismatch: 'Le password non corrispondono',
    requiredField: 'Questo campo è richiesto',
    minLength: 'Minimo {min} caratteri richiesti',
    maxLength: 'Massimo {max} caratteri consentiti',
    fillAllFields: 'Per favore compila tutti i campi richiesti',
    emailAlreadyUsed: 'Questa email è già in uso',
    companyAlreadyRegistered: 'Questa azienda è già registrata',
    registrationError: 'Errore durante la registrazione',
    genericError: 'Si è verificato un errore imprevisto',
    disposableEmailNotAllowed: 'Le email temporanee non sono consentite',
    personalEmailNotAllowed: 'L\'email {domain} non è consentita. Usa un\'email professionale.',
    invalidResetLink: 'Questo link di reimpostazione non è valido o è scaduto. Richiedi un nuovo link.',
    resetLinkExpired: 'Questo link di reimpostazione è scaduto. Richiedi un nuovo link.',
    resetPasswordFailed: 'Reimpostazione password non riuscita. Riprova.',
    passwordCriteriaNotMet: 'La password non soddisfa tutti i criteri richiesti.'
  },

  // Success messages
  success: {
    saved: 'Salvato con successo',
    deleted: 'Eliminato con successo',
    updated: 'Aggiornato con successo',
    created: 'Creato con successo',
    copied: 'Copiato negli appunti',
    sent: 'Inviato con successo',
    uploaded: 'Caricato con successo'
  },

  // Time
  time: {
    now: 'Ora',
    seconds: 'secondi',
    minutes: 'minuti',
    hours: 'ore',
    days: 'giorni',
    weeks: 'settimane',
    months: 'mesi',
    years: 'anni',
    ago: 'fa',
    in: 'tra'
  },

  // Credentials
  credentials: {
    title: 'Credenziali',
    username: 'Nome utente',
    password: 'Password',
    hash: 'Hash',
    domain: 'Dominio',
    source: 'Fonte',
    foundAt: 'Trovato il',
    noCredentials: 'Nessuna credenziale trovata',
    export: 'Esporta credenziali'
  },

  // Sessions
  sessions: {
    title: 'Sessioni',
    sessionDetails: 'Dettagli sessione',
    activeSession: 'Sessione attiva',
    closedSession: 'Sessione chiusa',
    sessionType: 'Tipo di sessione',
    target: 'Obiettivo',
    startedAt: 'Iniziato alle',
    endedAt: 'Terminato alle',
    duration: 'Durata',
    commands: 'Comandi',
    noSessions: 'Nessuna sessione',
    closeSession: 'Chiudi sessione',
    quickActions: 'Azioni rapide',
    quickCommands: 'Comandi rapidi',
    defaultSessionType: 'Terminale',
    sessionLabel: 'Sessione'
  },

  // Attack
  attack: {
    title: 'Centro di Attacco',
    description: 'Strumenti di attacco avanzati e orchestratore dinamico',
    selectTarget: 'Seleziona obiettivo',
    selectTechnique: 'Seleziona tecnica',
    launchAttack: 'Lancia attacco',
    attackInProgress: 'Attacco in corso',
    attackCompleted: 'Attacco completato',
    attackFailed: 'Attacco fallito',
    techniques: 'Tecniche',
    payloads: 'Payload',
    results: 'Risultati',
    dynamicOrchestrator: 'Orchestratore Dinamico',
    attackGraph: 'Grafo di Attacco',
    attackBuilder: 'Costruttore di Attacco'
  },
  // Active Directory
  ad: {
    title: 'Active Directory',
    description: 'Strumenti di attacco AD con assistenza AI LLM e PoC automatizzato',
    domain: 'Dominio',
    dcIp: 'IP del Domain Controller',
    username: 'Nome utente',
    password: 'Password',
    ntlmHash: 'Hash NTLM (opzionale)',
    dcConfiguration: 'Configurazione Domain Controller',
    attacks: 'Attacchi AD',
    ldapPentest: 'Pentest LDAP/LDAPS',
    searchPlaceholder: 'Cerca un attacco, uno strumento...',
    allCategories: 'Tutte le categorie',
    attackCategories: 'Categorie di Attacchi',
    targetResults: 'Obiettivo / Risultati',
    noDataMessage: 'Seleziona un attacco per iniziare',
    noDataHint: 'Oppure usa Auto PoC per una catena di attacchi',
    readyToStart: 'Pronto per iniziare',
    stats: {
      attacks: 'Attacchi',
      successful: 'Riusciti',
      failed: 'Falliti',
      credentials: 'Credenziali',
      users: 'Utenti',
      paths: 'Percorsi'
    }
  },

  // Branding (Login/Register pages)
  branding: {
    platformTitle: 'Piattaforma di',
    platformSubtitle: 'Pentest Autonomo',
    platformDescription: 'Analisi di sicurezza basata su IA con sfruttamento automatizzato e report dettagliati.'
  },

  // Features (Login/Register pages)
  features: {
    autonomousAI: {
      title: 'IA Autonoma',
      description: 'Intelligenza artificiale che simula un pentester esperto',
      highlight: 'SYLink LLM On-Premise'
    },
    advancedDetection: {
      title: 'Rilevamento Avanzato',
      description: 'Identificazione automatica delle vulnerabilità critiche',
      highlight: '200K+ CVE'
    },
    completeTests: {
      title: 'Test Completi',
      description: 'Scansioni di rete, web, API e infrastruttura',
      highlight: '100+ Strumenti'
    },
    instantReports: {
      title: 'Report Istantanei',
      description: 'Generazione automatica di report PDF professionali',
      highlight: 'Esporta PDF'
    }
  },

  // Stats (Login/Register pages)
  stats: {
    availability: 'Disponibilità',
    vulnerabilities: 'Vulnerabilità rilevate',
    monitoring: 'Monitoraggio',
    scanTime: 'Tempo medio di scansione'
  },

  // Footer
  footer: {
    title: 'Piattaforma Scanner di Sicurezza',
    subtitle: 'Sistema Autonomo di Penetration Test',
    terms: 'Termini di Utilizzo',
    sales: 'Termini di Vendita',
    privacy: 'Politica sulla Privacy',
    legalNotice: 'Note Legali',
    contact: 'Contatti',
    version: 'Versione',
    licence: 'Licenza n°'
  },

  // Enrichment - ABSpider Integration
  enrichment: {
    title: 'Arricchimento & Threat Intelligence',
    subtitle: 'Analisi avanzata di domini e IP con VirusTotal, header di sicurezza, email e geolocalizzazione',
    newScan: 'Nuova scansione',
    quickScan: 'Scansione rapida',
    fullScan: 'Scansione completa',
    viewDetails: 'Vedi dettagli',
    exportReport: 'Esporta rapporto',
    refresh: 'Aggiorna',
    scanTypes: {
      virustotal: 'VirusTotal',
      headers: 'Header di sicurezza',
      security_headers: 'Header di sicurezza',
      email_security: 'Sicurezza email',
      geoip: 'Geolocalizzazione IP',
      reverse_ip: 'Reverse IP',
      full: 'Scansione completa'
    },
    status: {
      pending: 'In attesa',
      running: 'In esecuzione',
      completed: 'Completato',
      failed: 'Fallito',
      cancelled: 'Annullato'
    },
    threatLevels: {
      safe: 'Sicuro',
      low: 'Basso',
      medium: 'Medio',
      high: 'Alto',
      critical: 'Critico'
    },
    form: {
      targetDomain: 'Dominio target',
      targetDomainPlaceholder: 'es: example.com',
      targetIp: 'Indirizzo IP (opzionale)',
      targetIpPlaceholder: 'es: 192.168.1.1',
      scanType: 'Tipo di scansione',
      workspace: 'Workspace (opzionale)',
      startScan: 'Avvia scansione',
      credits: 'Crediti richiesti'
    },
    results: {
      title: 'Risultati',
      noResults: 'Nessun risultato disponibile',
      loading: 'Caricamento risultati...',
      riskScore: 'Punteggio di rischio',
      threatLevel: 'Livello di minaccia',
      scannedAt: 'Scansionato il',
      duration: 'Durata'
    },
    headers: {
      title: 'Analisi header di sicurezza',
      score: 'Punteggio',
      grade: 'Voto',
      present: 'Presenti',
      missing: 'Mancanti',
      recommendations: 'Raccomandazioni',
      headerName: 'Header',
      value: 'Valore',
      status: 'Stato',
      issues: 'Problemi'
    },
    email: {
      title: 'Sicurezza email',
      mxRecords: 'Record MX',
      spf: 'SPF',
      dkim: 'DKIM',
      dmarc: 'DMARC',
      valid: 'Valido',
      invalid: 'Non valido',
      notFound: 'Non trovato',
      policy: 'Politica',
      vulnerabilities: 'Vulnerabilità rilevate',
      recommendations: 'Raccomandazioni'
    },
    geoip: {
      title: 'Geolocalizzazione IP',
      location: 'Posizione',
      country: 'Paese',
      region: 'Regione',
      city: 'Città',
      timezone: 'Fuso orario',
      isp: 'ISP',
      organization: 'Organizzazione',
      isProxy: 'Proxy rilevato',
      isVpn: 'VPN rilevato',
      isTor: 'Tor rilevato'
    },
    virustotal: {
      title: 'Analisi VirusTotal',
      reputation: 'Reputazione',
      malicious: 'Malevolo',
      suspicious: 'Sospetto',
      harmless: 'Innocuo',
      undetected: 'Non rilevato'
    },
    errors: {
      scanFailed: 'Scansione fallita',
      insufficientCredits: 'Crediti insufficienti',
      invalidDomain: 'Dominio non valido',
      networkError: 'Errore di rete'
    }
  },

  // Support
  support: {
    title: 'Supporto',
    myTickets: 'I miei ticket di supporto',
    newTicket: 'Nuovo ticket',
    createTicket: 'Crea un ticket',
    ticketDetails: 'Dettagli del ticket',
    ticketNumber: 'Ticket n°{number}',
    backToList: 'Torna alla lista',
    noTickets: 'Nessun ticket di supporto',
    noTicketsDescription: 'Non hai ancora creato alcun ticket di supporto.',
    subject: 'Oggetto',
    subjectPlaceholder: 'Descrivi brevemente il tuo problema',
    description: 'Descrizione',
    descriptionPlaceholder: 'Descrivi il tuo problema in dettaglio...',
    category: 'Categoria',
    priority: 'Priorità',
    status: 'Stato',
    createdAt: 'Creato il',
    updatedAt: 'Aggiornato il',
    lastResponse: 'Ultima risposta',
    messages: 'Messaggi',
    addResponse: 'Aggiungi una risposta',
    responsePlaceholder: 'Scrivi la tua risposta...',
    sendResponse: 'Invia',
    closeTicket: 'Chiudi ticket',
    reopenTicket: 'Riapri ticket',
    attachments: 'Allegati',
    addAttachment: 'Aggiungi un allegato',
    responseFromSupport: 'Risposta del supporto',
    yourResponse: 'La tua risposta',
    statuses: {
      open: 'Aperto',
      pending: 'In attesa',
      in_progress: 'In corso',
      waiting_customer: 'In attesa del cliente',
      waiting_support: 'In attesa del supporto',
      resolved: 'Risolto',
      closed: 'Chiuso'
    },
    priorities: {
      low: 'Bassa',
      medium: 'Media',
      high: 'Alta',
      urgent: 'Urgente',
      critical: 'Critica'
    },
    categories: {
      technical: 'Problema tecnico',
      billing: 'Fatturazione',
      account: 'Account',
      feature_request: 'Richiesta funzionalità',
      bug_report: 'Segnalazione bug',
      security: 'Sicurezza',
      other: 'Altro'
    },
    filters: {
      all: 'Tutti',
      open: 'Aperti',
      closed: 'Chiusi',
      myTickets: 'I miei ticket'
    },
    sort: {
      newest: 'Più recenti',
      oldest: 'Più vecchi',
      priority: 'Per priorità',
      status: 'Per stato'
    },
    notifications: {
      newResponse: 'Nuova risposta sul tuo ticket',
      statusChanged: 'Stato del ticket aggiornato',
      ticketClosed: 'Ticket chiuso'
    },
    help: {
      title: 'Hai bisogno di aiuto?',
      description: 'Il nostro team di supporto è disponibile per aiutarti.',
      responseTime: 'Tempo di risposta medio: meno di 24 ore',
      documentation: 'Consulta la documentazione',
      faq: 'Domande frequenti'
    },
    errors: {
      loadFailed: 'Impossibile caricare i ticket',
      createFailed: 'Impossibile creare il ticket',
      updateFailed: 'Impossibile aggiornare il ticket',
      responseFailed: 'Impossibile inviare la risposta',
      subjectRequired: 'L\'oggetto è obbligatorio',
      descriptionRequired: 'La descrizione è obbligatoria',
      categoryRequired: 'Seleziona una categoria'
    },
    success: {
      ticketCreated: 'Ticket creato con successo',
      responseSent: 'Risposta inviata con successo',
      ticketClosed: 'Ticket chiuso con successo',
      ticketReopened: 'Ticket riaperto con successo'
    }
  },

  // Pricing
  pricing: {
    title: 'Scegli il tuo piano',
    subtitle: 'Soluzioni adatte a ogni esigenza di sicurezza',
    monthly: 'Mensile',
    annually: 'Annuale',
    save: 'Risparmia {percent}%',
    perMonth: '/mese',
    perYear: '/anno',
    currentPlan: 'Il tuo piano attuale',
    selectPlan: 'Seleziona',
    contactUs: 'Contattaci',
    popular: 'Popolare',
    enterprise: 'Enterprise',
    plans: {
      gratuit: {
        name: 'Gratuito',
        description: 'Per scoprire la piattaforma',
        price: '0',
        features: [
          '1 scansione al mese',
          '1 workspace',
          'Report base',
          'Supporto community'
        ]
      },
      pro: {
        name: 'Pro',
        description: 'Per professionisti indipendenti',
        price: '99',
        features: [
          '50 scansioni al mese',
          '5 workspace',
          'Report avanzati PDF',
          'API access',
          'Supporto prioritario'
        ]
      },
      entreprise: {
        name: 'Enterprise',
        description: 'Per team e aziende',
        price: '299',
        features: [
          'Scansioni illimitate',
          'Workspace illimitati',
          'Report white-label',
          'API completa',
          'SSO/SAML',
          'Account manager dedicato'
        ]
      },
      groupe: {
        name: 'Gruppo',
        description: 'Per grandi organizzazioni',
        price: 'Personalizzato',
        features: [
          'Tutte le funzionalità Enterprise',
          'Deployment on-premise',
          'Integrazioni personalizzate',
          'SLA garantito',
          'Formazione inclusa'
        ]
      },
      dedicated: {
        name: 'Dedicato',
        description: 'Infrastruttura dedicata',
        price: 'Personalizzato',
        features: [
          'Server dedicati',
          'Personalizzazione completa',
          'Isolamento totale dei dati',
          'Audit di sicurezza',
          'Supporto 24/7'
        ]
      }
    },
    features: {
      scans: 'Scansioni',
      workspaces: 'Workspace',
      reports: 'Report',
      api: 'API Access',
      support: 'Supporto',
      sso: 'SSO/SAML',
      whitelabel: 'White-label',
      onpremise: 'On-premise',
      unlimited: 'Illimitato'
    },
    faq: {
      title: 'Domande frequenti',
      questions: {
        q1: {
          question: 'Posso cambiare piano in qualsiasi momento?',
          answer: 'Sì, puoi fare upgrade o downgrade del tuo piano in qualsiasi momento. La modifica sarà effettiva al prossimo ciclo di fatturazione.'
        },
        q2: {
          question: 'È disponibile un periodo di prova?',
          answer: 'Sì, offriamo 14 giorni di prova gratuita su tutti i piani a pagamento per testare la piattaforma.'
        },
        q3: {
          question: 'Quali metodi di pagamento accettate?',
          answer: 'Accettiamo carte di credito (Visa, Mastercard, Amex), bonifici bancari e PayPal.'
        },
        q4: {
          question: 'I prezzi includono l\'IVA?',
          answer: 'I prezzi visualizzati sono al netto dell\'IVA. L\'IVA verrà aggiunta in base al tuo paese.'
        }
      }
    },
    cta: {
      startTrial: 'Inizia la prova gratuita',
      getStarted: 'Inizia',
      talkToSales: 'Parla con le vendite',
      comparePlans: 'Confronta i piani'
    }
  },

  // Notifications
  notifications: {
    title: 'Notifiche',
    managementCenter: 'Centro di gestione degli avvisi e degli eventi',
    markAllRead: 'Segna tutto come letto',
    clearAll: 'Cancella tutto',
    noNotifications: 'Nessuna notifica',
    noNotificationsDescription: 'Non hai alcuna notifica al momento',
    viewAll: 'Vedi tutte le notifiche',
    settings: 'Impostazioni notifiche',
    loadMore: 'Carica altre',
    justNow: 'Proprio ora',
    minutesAgo: '{count} minuti fa',
    hoursAgo: '{count} ore fa',
    daysAgo: '{count} giorni fa',
    scanRunning: 'Scansione in corso',
    viewAll: 'Visualizza tutte le notifiche',
    scanCompleted: 'Scansione completata',
    criticalVulnsFound: '{count} vulnerabilità critica{count, plural, =1 {} other {}}',
    types: {
      scan_completed: 'Scansione completata',
      scan_failed: 'Scansione fallita',
      vulnerability_found: 'Vulnerabilità rilevata',
      report_ready: 'Report pronto',
      subscription_expiring: 'Abbonamento in scadenza',
      credits_low: 'Crediti bassi',
      new_feature: 'Nuova funzionalità',
      system: 'Sistema'
    },
    filters: {
      all: 'Tutte',
      unread: 'Non lette',
      read: 'Lette',
      important: 'Importanti'
    },
    preferences: {
      title: 'Preferenze di notifica',
      email: 'Notifiche email',
      push: 'Notifiche push',
      inApp: 'Notifiche in-app',
      scanUpdates: 'Aggiornamenti scansioni',
      securityAlerts: 'Avvisi di sicurezza',
      productNews: 'Novità prodotto',
      weeklyReport: 'Report settimanale'
    },
    status: {
      read: 'Letto',
      unread: 'Non letto'
    }
  },

  // Antivirus (ClamAV)
  antivirus: {
    title: 'Scanner Antivirus',
    subtitle: 'Scansiona i file alla ricerca di malware con ClamAV',
    adminTitle: 'Gestione Antivirus',
    adminSubtitle: 'Monitora ClamAV e gestisci la quarantena',
    scannerTab: 'Scanner File',
    adminTab: 'Amministrazione',

    // File Upload
    dropzone: 'Trascina un file qui o clicca per caricare',
    dropzoneActive: 'Rilascia il file qui...',
    scanning: 'Scansione in corso...',
    uploadAndScan: 'Carica e Scansiona',
    maxFileSize: 'Dimensione massima file: {size}',

    // Scan Results
    scanResult: 'Risultato scansione',
    clean: 'Pulito',
    infected: 'Infetto',
    error: 'Errore',
    pending: 'In attesa',
    threatDetected: 'Minaccia rilevata',
    noThreatsFound: 'Nessuna minaccia trovata',
    threatName: 'Nome minaccia',
    scanTime: 'Tempo di scansione',
    fileHash: 'Hash file',

    // History
    scanHistory: 'Cronologia scansioni',
    noScansYet: 'Nessuna scansione ancora',
    noScansYetDesc: 'Carica un file per iniziare la scansione',

    // Admin Dashboard
    clamavStatus: 'Stato ClamAV',
    version: 'Versione',
    signatureCount: 'Numero firme',
    lastUpdate: 'Ultimo aggiornamento',
    databaseStatus: 'Stato database',
    upToDate: 'Aggiornato',
    outdated: 'Obsoleto',

    // Statistics
    statistics: 'Statistiche',
    totalScans: 'Scansioni totali',
    cleanFiles: 'File puliti',
    infectedFiles: 'File infetti',
    errorScans: 'Scansioni con errore',

    // Quarantine
    quarantine: 'Quarantena',
    quarantineEmpty: 'Quarantena vuota',
    quarantineEmptyDesc: 'Nessun file in quarantena',
    deleteFromQuarantine: 'Elimina dalla quarantena',
    cleanupQuarantine: 'Pulisci quarantena',

    // Errors
    uploadError: 'Errore durante il caricamento del file',
    scanError: 'Errore durante la scansione del file',
    fileTooLarge: 'Il file è troppo grande',
    invalidFileType: 'Tipo di file non valido',
    serviceUnavailable: 'Servizio antivirus non disponibile'
  },

  // Contracts
  contracts: {
    title: 'Contratti',
    contract: 'Contratto',
    newContract: 'Nuovo contratto',
    createContract: 'Crea contratto',
    editContract: 'Modifica contratto',
    contractNumber: 'Numero contratto',
    contractTitle: 'Titolo',

    // Status
    status: {
      draft: 'Bozza',
      pending_signature: 'In attesa di firma',
      signed: 'Firmato',
      active: 'Attivo',
      completed: 'Completato',
      expired: 'Scaduto',
      cancelled: 'Annullato'
    },

    // Provider
    provider: 'Fornitore',
    providerInfo: 'Informazioni fornitore',
    providerName: 'Nome azienda',
    providerSiret: 'SIRET',
    providerAddress: 'Indirizzo',

    // Client
    client: 'Cliente',
    clientInfo: 'Informazioni cliente',
    clientName: 'Nome azienda',
    clientRepresentative: 'Rappresentante del cliente',
    clientContact: 'Contatto',

    // Perimeter
    perimeter: 'Perimetro',
    perimeterDescription: 'Intervalli IP e obiettivi da testare',
    addPerimeterItem: 'Aggiungi elemento al perimetro',

    // Period
    interventionPeriod: 'Periodo di intervento',
    startDate: 'Data inizio',
    endDate: 'Data fine',
    riskPeriod: 'Periodo di rischio (giorni)',

    // Signature
    signature: {
      title: 'Firma elettronica',
      sign: 'Firma',
      signed: 'Firmato',
      pendingSignature: 'In attesa di firma',
      signContract: 'Firma contratto',
      signatureType: 'Tipo di firma',
      typed: 'Digitata',
      drawn: 'Disegnata',
      uploaded: 'Caricata',

      // Signatory
      signatory: 'Firmatario',
      signatoryInfo: 'Identità del firmatario',
      signatoryFirstName: 'Nome',
      signatoryLastName: 'Cognome',
      signatoryEmail: 'Email',
      signatoryFullName: 'Nome completo',

      // Legal
      legalMention: 'Menzione legale',
      legalAcceptance: 'Accetto i termini del contratto',
      acceptTerms: 'Confermo di aver letto e accettato questo contratto di pentest',

      // Verification
      verification: 'Verifica',
      verificationMethod: 'Metodo di verifica',
      smsVerification: 'Verifica SMS',
      smsCode: 'Codice SMS',
      sendCode: 'Invia codice',
      verifyCode: 'Verifica codice',
      codeExpired: 'Codice scaduto',
      invalidCode: 'Codice non valido',
      codeSent: 'Codice inviato al tuo telefono',

      // Metadata (DocuSign-style)
      metadata: 'Metadati della firma',
      signedBy: 'Firmato da',
      signedAt: 'Firmato il',
      signedAtTime: 'Ora della firma',
      ipAddress: 'Indirizzo IP',
      userAgent: 'Browser / Dispositivo',
      geolocation: 'Posizione',

      // Certificate
      certificate: 'Certificato di firma',
      certificateOfCompletion: 'Certificato di completamento',
      signatureCertificate: 'Certificato di firma',
      downloadCertificate: 'Scarica certificato',
      viewCertificate: 'Visualizza certificato',

      // Integrity
      integrity: 'Integrità del documento',
      documentHash: 'Hash del documento (SHA-512)',
      signatureHash: 'Hash della firma (SHA-512)',
      hashVerified: 'Hash verificato',
      hashMismatch: 'Errore hash',

      // Timeline / Audit
      timeline: 'Cronologia',
      auditTrail: 'Registro di audit',
      eventLog: 'Registro eventi',
      created: 'Creato',
      sent: 'Inviato',
      viewed: 'Visualizzato',
      signatureStarted: 'Firma avviata',
      signatureCompleted: 'Firma completata',

      // Success
      success: 'Contratto firmato con successo!',
      successMessage: 'Il contratto è stato firmato ed è ora attivo.',
      thankYou: 'Grazie per la tua firma',

      // Errors
      error: 'Errore di firma',
      errorMessage: 'Impossibile firmare il contratto',
      expired: 'Link di firma scaduto',
      alreadySigned: 'Contratto già firmato',
      invalidToken: 'Link di firma non valido'
    },

    // Actions
    send: 'Invia per la firma',
    resend: 'Invia di nuovo',
    cancel: 'Annulla contratto',
    download: 'Scarica PDF',
    downloadSigned: 'Scarica PDF firmato',
    preview: 'Anteprima',

    // Notifications
    sentSuccess: 'Contratto inviato per la firma',
    signedSuccess: 'Contratto firmato con successo',
    cancelledSuccess: 'Contratto annullato'
  },

  // VPN Configuration
  vpn: {
    title: 'Configurazione VPN',
    configurations: 'Configurazioni VPN',
    noConfigurations: 'Nessuna configurazione VPN',
    uploadConfig: 'Carica configurazione',
    connected: 'Connesso',
    disconnected: 'Disconnesso',
    connecting: 'Connessione...',
    disconnecting: 'Disconnessione...',
    connect: 'Connetti',
    disconnect: 'Disconnetti',
    status: 'Stato VPN',
    protocol: 'Protocollo',
    interface: 'Interfaccia',
    publicIp: 'IP Pubblico',
    vpnIp: 'IP VPN',
    country: 'Paese',
    city: 'Città',
    connectedSince: 'Connesso da',
    routes: {
      title: 'Route di Rete',
      description: 'Gestisci route di rete personalizzate per VPN',
      addRoute: 'Aggiungi route',
      destination: 'Destinazione CIDR',
      destinationPlaceholder: '192.168.56.0/24',
      gateway: 'Gateway',
      gatewayPlaceholder: '192.168.10.1',
      routeDescription: 'Descrizione',
      routeDescriptionPlaceholder: 'Rete interna cliente',
      noRoutes: 'Nessuna route configurata',
      deleteRoute: 'Elimina route',
      applyRoutes: 'Applica route',
      routeAdded: 'Route aggiunta con successo',
      routeDeleted: 'Route eliminata',
      routesApplied: 'Route applicate',
      invalidCidr: 'Formato CIDR non valido',
      invalidGateway: 'Indirizzo IP non valido',
      active: 'Attiva',
      inactive: 'Inattiva'
    },
    topology: {
      title: 'Topologia di Rete',
      server: 'Server Sylink',
      internet: 'Internet',
      vpnGateway: 'Gateway VPN',
      clientNetwork: 'Rete Cliente',
      online: 'Online',
      offline: 'Offline',
      activeRoutes: 'Route attive',
      totalRoutes: 'Route totali'
    },
    messages: {
      configUploaded: 'Configurazione VPN caricata',
      configDeleted: 'Configurazione VPN eliminata',
      connectionSuccess: 'VPN connesso con successo',
      connectionFailed: 'Errore connessione VPN',
      disconnectionSuccess: 'VPN disconnesso',
      disconnectionFailed: 'Errore disconnessione VPN'
    }
  }

};
